// extracted by mini-css-extract-plugin
export default {"wrapper":"SkeletonUserChats_wrapper__qdWjh","content":"SkeletonUserChats_content__CKuzF"};